$ = require 'jquery'

JswCrossflowPopoverView = require 'app/scripts/views/board/jsw-crossflow-popover-view'
JSWTouchpointExperiment = require './touchpoint-jsw-experiment-activation'
module.exports.renderJswCrossflowPopover = ->
  if !JSWTouchpointExperiment.isBoardActive()
    return

  @$('.board-canvas').append('<div class="jsw-crossflow-popover-mount-point"></div>')

  popoverView = @subview JswCrossflowPopoverView, @model,
    modelCache: @modelCache

  @ensureSubview(popoverView, @$('.jsw-crossflow-popover-mount-point'))
